import styled from "@emotion/styled"
import { Grid } from "@mui/material"

const GridWrapper = styled(Grid)`
min-height: calc(80vh - 0px);
@media screen and (max-width:1100px){
    /* min-height: calc(78vh - 0px); */
}
@media screen and (max-width:900px){
    /* min-height: calc(73vh - 0px); */
}
@media screen and (max-width:600px){
    /* min-height: calc(77vh - 0px); */
}
`

const ConnectButt = styled.button`
background: ${props => props.disabled ? 'gray' : (props.bgcolor ? props.bgcolor : "linear-gradient(60deg, #4B5C68 43%, #364753 60%,#364753 60%,#4B5C68 92%)")};
width: 100%;
max-width: ${(props) => (props.mw ? props.mw : "20%")};
margin: ${(props) => (props.m ? props.m : "")};
padding: ${(props) => (props.p ? props.p : "11px 0px")};
border-radius: 10px;
font-family: "P-SM";
font-size: 18px;
color: ${(props) => props.theme.textPrimary};
text-decoration:none ;
cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
border: 1px solid ${(props) => (props.border ? props.border : "none")};

@media screen and (max-width:599px){
  max-width: ${(props) => (props.mw599 ? props.mw599 : "100%")};
}
`

const PageCount = styled.div`
color: ${(props) => props.theme.textPrimary};
letter-spacing: 4px;
text-align: center;
padding: 20px 0;
`
const PageCounted = styled.span`
color: ${(props) => props.theme.textTertiary};   
`
const InpuDIv = styled.div`
background-color: ${(props) => props.theme.bgTertiary};
padding: 30px 20px;
border-radius:10px;
color:${(props) => props.theme.textTertiary};
word-wrap: break-word;
`

const Split = styled.div`
display:flex;
justify-content: space-between;
align-items: center;
padding: 10px 0;
`
const Divider  = styled.div`
border-bottom: 1px solid ${(props) => props.theme.textPrimary};
padding: 10px 0;
`

const InputNote = styled.input`
  border: none;
  background-color: ${(props) => (props.bgcolor ? props.bgcolor : props.theme.bgInput)};
  color: ${(props) => (props.bgcolor ? props.bgcolor : props.theme.textPrimary)};
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 10px;
  width: 100%;
  font-size: 16px;
  &:focus {
    outline: none;
  }
`;

export{GridWrapper,ConnectButt,PageCounted,InpuDIv,PageCount,Split,Divider,InputNote }